import { useIntl } from 'react-intl';

import { ContentWrapper } from '@/components/b2b/shared/styles';
import { Grid, StoreButtonsWrapper, SuccessText } from '@/components/b2b/Success/styles';
import SuccessButton from '@/components/b2b/Success/SuccessButton';
import { BlueLine } from '@/components/b2b/Welcome/styles';
import { StoreButton } from '@/components/ui/StoreButton';
import { useAnalytics } from '@/hooks/analytics';
import { useComponentDidMount } from '@/hooks/utils/useComponentDidMount';

import { SignupScreenProps } from '../../shared/types';
import messages from './messages';
import { SuccessHead } from './styles';

const AccessSuccess = ({
	partnerDetails: {
		pageInfo: { messages: partnerMessages, successCTAUrl },
	},
}: SignupScreenProps) => {
	const { logEvent } = useAnalytics();
	const { formatMessage } = useIntl();

	useComponentDidMount(() => {
		logEvent({ eventName: 'Request Access Success : Landed' });
	});

	return (
		<Grid allowOverflow>
			<ContentWrapper>
				<SuccessHead>{formatMessage(messages.congrats)}</SuccessHead>
				<BlueLine />
				<SuccessText>
					{formatMessage(partnerMessages?.successText ?? messages.successText, {
						breakingLine: <p />,
					})}
				</SuccessText>
				<StoreButtonsWrapper>
					<StoreButton type="ios" />
					<StoreButton type="android" />
				</StoreButtonsWrapper>
				<SuccessButton successCTAUrl={successCTAUrl} />
			</ContentWrapper>
		</Grid>
	);
};

export default AccessSuccess;
